// angular import
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
// services import
import { AccountService } from './../../service/accountService.service';
import { Locale } from './../../service/locale.service';
import { ServerMapping } from './../../service/serverMapping.service';
// manager import
import { ModelsManager } from '../../manager/models.manager';
import { GrowlManager } from './../../manager/growl.manager';
// models import
import { DeliveryRequest } from './../../model/delivery/delivery_request.model';
import { DeliveryResponse } from './../../model/delivery/delivery_response.model';

@Injectable()
export class DeliveryService {

  private searching = false;

  private deliveries = [];

  constructor(private accountService: AccountService,
              private serverMapping:  ServerMapping,
              private growlManager:   GrowlManager,
              private locale:         Locale,
              private http:           Http,
              private modelManager:   ModelsManager) {
  }

  isSearching() { return this.searching; }

  getDeliveries() { return this.deliveries; }

  serchDelivery() {
    if (this.searching === false) {
      this.searching = true;
    }
    this.http.get(this.serverMapping.deliverySearchURL +
      '?document_number=' + this.modelManager.delivery_request.order_number +
      '&language=' + this.modelManager.delivery_request.language +
      '&company_code=' + this.modelManager.delivery_request.company_code +
      '&supplier_code=' + this.modelManager.delivery_request.supplier_code). subscribe
      (
        (response) => {
          // store the response
          const data = response.json();

          // TODO : GROWL MANAGER
          if (this.growlManager.checkForErrorInResponse(data)) {
            this.growlManager.showMessagesByResponse(data);
          }else {
            this.deliveries = data.contained_bean;
          }
          this.searching = false;
        },
        (error) => {
          console.log('--------------------------------');
          console.log('!!!An error has been occurred!!!');
          console.log(error);
          console.log('--------------------------------');
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/delivery/delivery.service.ts